import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
const OrganizationRow = props => {
  const onClick = props.onClick,
    id = props.id;
  const handleClick = () => onClick(id);
  const newProps = _objectSpread(_objectSpread({}, props), {}, {
    onClick: handleClick
  });
  return /*#__PURE__*/React.createElement("tr", newProps);
};
OrganizationRow.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default OrganizationRow;